import { emptyObject } from "../datatypes/ObjectUtils.js";
import { ETaskFunctionEndId, } from "./TaskFunctionTypes.js";
import { TaskFunctionError } from "./TaskFunctionUtils.js";
import { _getDefaultErrorMessageForEndId } from "./TaskFunctionUtils/_getHttpStatusCodeForEndId.js";
export const TFR = ({ positive = true, endId = ETaskFunctionEndId.SUCCESS, endMessage = "", endTags = [], payload = {}, errorPayload = null, taskId = null, } = emptyObject) => {
    if (positive) {
        return {
            positive,
            endId,
            endMessage,
            endTags,
            payload,
            errorPayload,
            taskId,
        };
    }
    else {
        return {
            positive,
            endId,
            endMessage,
            endTags,
            payload,
            errorPayload,
            taskId,
        };
    }
};
export const TFRSuccessPayload = (responseObject, responseMessage = "", endTags = []) => ({
    positive: true,
    endId: ETaskFunctionEndId.SUCCESS,
    endMessage: responseMessage,
    endTags,
    payload: responseObject,
    errorPayload: null,
});
export const TFRSuccess = (responseObject = {}, responseMessage = "", endTags = []) => {
    return {
        positive: true,
        endId: ETaskFunctionEndId.SUCCESS,
        endMessage: responseMessage,
        endTags,
        payload: responseObject,
        errorPayload: null,
    };
};
export const TFRFailure = (errorId, reason, errorPayload = {}) => {
    return {
        positive: false,
        endId: errorId,
        endMessage: reason ? reason : _getDefaultErrorMessageForEndId(errorId),
        endTags: [],
        payload: null,
        errorPayload,
    };
};
export const TFRSuccessDefaults = ({ endMessage = "Finished successfully", endTags = [], labels, payload = {}, taskId = null, } = {}) => ({
    positive: true,
    errorPayload: null,
    endId: ETaskFunctionEndId.SUCCESS,
    payload,
    endMessage,
    endTags,
    labels,
    taskId,
});
export const TFRFailureDefaults = ({ endId = ETaskFunctionEndId.ERROR, endMessage, endTags = [], labels, errorPayload = {}, taskId = null, } = {}) => ({
    positive: false,
    payload: null,
    endId,
    endMessage: endMessage ? endMessage : _getDefaultErrorMessageForEndId(endId),
    endTags,
    labels,
    errorPayload,
    taskId,
});
export function TFRErrorBuilder() {
    const endIds = [];
    const tags = [];
    const labels = [];
    const messages = [];
    const hasErrors = () => endIds.length > 0;
    const finalize = () => {
        if (hasErrors()) {
            return TFRFailureDefaults({
                labels: labels.length > 0 ? labels : undefined,
                endTags: tags,
                endId: endIds[0],
                endMessage: messages[0],
            });
        }
        return TFRFailureDefaults();
    };
    return {
        id: (endId, message) => {
            endIds.push(endId);
            messages.push(message);
        },
        tag: (endId, tag, message) => {
            endIds.push(endId);
            tags.push(tag);
            messages.push(message);
        },
        label: (endId, label, message) => {
            endIds.push(endId);
            tags.push(label.tag);
            labels.push(label);
            messages.push(message);
        },
        hasErrors,
        throwIfErrors: () => {
            if (hasErrors()) {
                throw new TaskFunctionError(finalize());
            }
        },
        finalize,
    };
}
